import type { KeyboardEvent } from 'react';
import scrollIntoViewIfNeeded from 'scroll-into-view-if-needed';
import { DEFAULT_SCROLL_OPTIONS } from '@atlassian/jira-issue-create-common-types/src/common/constants/index.tsx';
import { getFieldContainerId } from '@atlassian/jira-issue-create-commons/src/common/utils/index.tsx';
import { ESC_KEY_KEYCODE } from '../constants/index.tsx';

// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export { transformQueryResults } from './fetch-config-query';
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export { useWindowSize } from './use-window-size';
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export { openInNewTabLinkClickEventHandler } from './link-handler';

export const scrollToElement = (elementId: string) => {
	// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
	const fieldRef = document.getElementById(elementId);
	if (fieldRef) {
		scrollIntoViewIfNeeded(fieldRef, DEFAULT_SCROLL_OPTIONS);
	}
};

export const preventEscKeyPropagationKeyPressHandler = (
	event: KeyboardEvent | KeyboardEvent<EventTarget>,
) => {
	if (event?.keyCode === ESC_KEY_KEYCODE) {
		event?.nativeEvent?.stopImmediatePropagation();
	}
};

export const scrollToField = (fieldId: string): void => {
	// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
	const fieldWithErrorRef = document.getElementById(getFieldContainerId(fieldId));
	if (fieldWithErrorRef) {
		scrollIntoViewIfNeeded(fieldWithErrorRef, DEFAULT_SCROLL_OPTIONS);
	}
};

const getFieldId = (fieldId: string) => `${fieldId}-field`;

export const setFocusOnField = (fieldId: string): void => {
	// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
	const fieldWithErrorRef = document.getElementById(getFieldId(fieldId));
	if (fieldWithErrorRef) {
		fieldWithErrorRef.focus?.();
	}
};
